import { type AxiosResponse, type AxiosError, CanceledError, isCancel } from 'axios'
import { CheckInternet } from 'shared/store/CheckInternet'
import { normalizeApiError } from 'shared/api'
import { sentEventSentry } from 'entities/Sentry/lib/sentEventSentry'
import { setTokenLocalStorageViaConfig } from 'entities/Auth/lib/setToken'
import { rejectRefreshToken } from 'entities/Auth/lib/rejectRefreshToken'
import { change_auth_domain_api } from 'entities/Auth/lib/change_api_domain'

export const interceptorsResponseSuccess = (config: AxiosResponse, isAssume: boolean) => {
  setTokenLocalStorageViaConfig(config, isAssume)

  return config
}

export const interceptorsResponseError = (error: AxiosError<{ auth_required: boolean }>) => {
  return rejectRefreshToken(error)
}

export const interceptorsApiError = (error: AxiosError) => {
  error.errors = normalizeApiError(error)

  return Promise.reject(error)
}

export const interceptorsResponseLogError = (error: AxiosError) => {
  if (error.code === 'ERR_NETWORK') CheckInternet.setIsOnline(false)

  if (error.config?.enabledChangeDomainApi && !isCancel(error) && !error.response) {
    return change_auth_domain_api.initNextDomain(error)
  }

  if (error instanceof CanceledError) return Promise.reject(error)

  if (error.response) {
    error.name = `Request error with status code: ${error.response.status}`

    sentEventSentry({
      event: '',
      error: error,
      name: 'axios',
      level: 'error',
      tags: {
        ['request.transport']: 'axios',
        ['status.code']: error.response.status,
        ['api.pathname']: error.response.config.url,
        ['api.method']: error.response.config.method,
      },
      fingerprint: [
        `${error.response.config.baseURL}${error.response.config.url}`,
        `${error.response.config.method}`,
        `${error.response.status}`,
      ],
      extra: {
        url: `${error.response.config.baseURL}${error.response.config.url}`,
        payload: error.response.config.data,
        response: error.response.data,
        status: error.response.status,
        method: error.response.config.method,
      },
    })
  }

  return Promise.reject(error)
}
